import {
  IBodyScanClinic,
  IClinic,
  IKeywords,
  MajorCategories,
} from '@alpha/types';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { DialogService } from 'app-shared-ui';
import { Subject, takeUntil } from 'rxjs';
import { AppLogger, ICardGroupItem, ICardItem, Util } from 'app-core';
import { CacheService, SearchService } from 'app-service';

import CardType = Data.Core.CardType;

@Component({
  selector: 'app-select-clinic',
  templateUrl: './select-clinic.component.html',
  styleUrls: ['./select-clinic.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [DialogService],
})
export class SelectClinicComponent implements OnInit, OnDestroy {
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  private listObj: Array<ICardItem> = [];
  public cards: Array<ICardGroupItem> = [];
  private profileId: string = '';

  public constructor(
    private readonly _cacheService: CacheService,
    private readonly _cdRef: ChangeDetectorRef,
    private readonly _doctorService: SearchService,
    private readonly _route: Router,
    private readonly _router: ActivatedRoute,
  ) {}

  public ngOnInit(): void {
    this.profileId = this._route.url.split('/')[2];
    this.profileId = this.profileId.split('?')[0];

    this._router.queryParamMap
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((paramMap: ParamMap) => {
        if (!!this._cacheService.getItem('l')) {
          const params = Util.processParameters(paramMap);
          params.location!.subDistrict = [
            Number(this._cacheService.getItem('l')),
          ];

          if (Number(params.category) === MajorCategories.Doctor) {
            this.getClinicProfileByDoctorId(this.profileId, params);
          }

          if (Number(params.category) === MajorCategories.BodyScan) {
            this.getBodyScanClinicProfileByDoctorId(this.profileId, params);
          }
        }
      });
  }

  private getClinicProfileByDoctorId(
    doctorId: string,
    filter: Partial<IKeywords>,
  ): void {
    this._doctorService
      .findAllClinicsByFilter(doctorId, filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: Array<IClinic>) => {
        if (res && res!.length > 0) {
          this.cards = [];
          this.listObj = [];
          res.forEach((clinic) => {
            let mobile = 'tel:';
            clinic.helpline?.map(
              (item: any, index) => (mobile += index === 0 ? item : ',' + item),
            );
            const contact: string = mobile.toString() || '';
            this.listObj.push({
              title: clinic.name || '',
              subTitle: clinic.location?.city || '',
              type: MajorCategories.Hospital,
              phone: contact,
              map: clinic.location?.mapURL,
              _id: clinic._id,
              online: clinic.online === undefined ? 0 : clinic.online,
              onArrowClick: (item: any) => {
                this.onArrowClick(doctorId, item._id);
              },
            });
          });
          this.cards.push({
            items: this.listObj,
            type: CardType.lg,
          });
        }
        this._cdRef.markForCheck();
      });
  }

  private getBodyScanClinicProfileByDoctorId(
    doctorId: string,
    filter: Partial<IKeywords>,
  ): void {
    this._doctorService
      .findAllScanClinicsByFilter(doctorId, filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: Array<IBodyScanClinic>) => {
        if (res && res!.length > 0) {
          this.cards = [];
          this.listObj = [];
          res.forEach((clinic) => {
            let mobile = 'tel:';
            clinic.helpline?.map(
              (item: any, index) => (mobile += index === 0 ? item : ',' + item),
            );
            const contact: string = mobile.toString() || '';
            this.listObj.push({
              title: clinic.name || '',
              subTitle: clinic.location?.city || '',
              type: MajorCategories.Hospital,
              phone: contact,
              map: clinic.location?.mapURL,
              _id: clinic._id,
              online: clinic.online === undefined ? 0 : clinic.online,
              onArrowClick: (item: any) => {
                this.onArrowClick(doctorId, item._id);
              },
            });
          });
          this.cards.push({
            items: this.listObj,
            type: CardType.lg,
          });
        }
        this._cdRef.markForCheck();
      });
  }

  private onArrowClick(id1: string, id2: string): void {
    const route = `/appointment/appointment/${id1}/${id2}`;
    this._route
      .navigate([route], { queryParamsHandling: 'preserve' })
      .catch((err: string | Error) => AppLogger.Error(err));
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
